export default "__VITE_ASSET__CXgLKT2t__"